'use strict';

DoohApps
.directive('heightChangeSource', [function () {
    return {
        link: function (scope, elem, attrs) {
            scope.$watch(function () {
                scope.__height = elem.height();
            });
        }
    }
}]);